<template>
    <div >
        <div class="warp">
            <!-- <el-input v-model="path" :disabled="true" class="super_input" v-if="!isMultiple"></el-input> -->
            <el-upload  class="avatar-uploader"
                    ref="upload"
                    :action="baseUrl+action"
                    :show-file-list="showFileList"
                    :accept="accept"
                    :limit="1"
                    :before-upload="beforeUpload"
                    :http-request="myupload"
                   
                    slot="suffix">
                    <img v-if="currentFile && currentFile.url" :src="currentFile.url" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <div class="el-upload__tip" slot="tip" v-if="tip">{{tip}}</div>
                </el-upload>
            
        </div>
        
        <el-dialog
          title="图片剪裁"
          :visible.sync="dialogVisible"
          v-if="dialogVisible"
          append-to-body
        >
          <cropperDialog
            :option="option"
            @finishUploadEvent="finishUploadEvent"
            :visible.sync="dialogVisible"
          ></cropperDialog>
        </el-dialog>

    </div>
</template>

<script>
import {API} from "@/axios/config";
import cropperDialog from './cropperDialog.vue'
export default {
    props:{
        base: { type: String, default: '' },
        showFileList: { type: Boolean, default: false },
        action:String,
        accept:String, //图片image/png,image/jpg,image/jpeg,image/bmp; 文件application/pdf ; xlx和xlsx application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        size:{type:Number,default:5},//以m为基数
         // eslint-disable-next-line vue/require-default-prop
        value: [String, Array],
        // 是否需要验证上传图片尺寸
        isNeedLimit: { type: Boolean, default: false },
        scale: { type: Array, default: () => [] },
        sizeList: { type: Array, default: () => [1 / 1] },
        isMultiple: { type: Boolean, default: false },
        limit: { type: Number, default: 1 },
        tip:{
          type:String,default:''
        },
        autoCropHeight:{type:Number,default:200},
        autoCropWidth:{type:Number,default:200},
        fixedNumber: { type: Array, default: () => [1,1] },
        isCalTotal: { type: Boolean, default: false }, // 是否计算合计大小
        videoSize:{ type: Number, default: 100 },// 视频大小 以m为基数
        isAvatar: { type: Boolean, default: false },
    },
    components:{
      cropperDialog
    },
    data(){
        return{
            baseUrl:API.UploadsService,//服务器
            // fileInfo:{},//文件数据
            // sizeList: [48 / 8],
            temp: [],
            activeIdx: 0,
            isUpload:true,
            fileList:[],//显示文件列表
            fileSizeList:[],//临时存储文件size数组
            dialogVisible:false,
            option: {
              img: "", // 裁剪图片的地址
              info: true, // 裁剪框的大小信息
              outputSize: 1, // 裁剪生成图片的质量
              outputType: "png", // 裁剪生成图片的格式
              canScale: true, // 图片是否允许滚轮缩放
              autoCrop: true, // 是否默认生成截图框
              autoCropWidth: this.autoCropWidth ? this.autoCropWidth : 480,
              autoCropHeight: this.autoCropHeight ? this.autoCropHeight : 200,
              fixedBox: false, // 固定截图框大小 不允许改变
              fixed: true, // 是否开启截图框宽高固定比例
              fixedNumber: void 0, // 截图框的宽高比例
              full: true, // 是否输出原图比例的截图
              canMoveBox: false, // 截图框能否拖动
              original: false, // 上传图片按照原始比例渲染
              centerBox: false, // 截图框是否被限制在图片里面
              infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            upAction:void 0,
            currentFile: {
              base: void 0,
              url: void 0
            }
        }
    },
    computed:{
        path:{
            get: function () {
                return this.isMultiple?(this.value[0] || ''):this.value;
            },
            set: function (val) {

            }
        }
    },
    watch:{
     
      base:{
        handler(val) {
        this.$nextTick(() => {
          this.currentFile.base = val
        })
        },
        immediate: true,
        deep: true
        },
      value:{
        handler(newVal,oldVal) {
          this.$nextTick(() => {
            this.path = newVal
            if(newVal !== oldVal){
              this.currentFile.url= this.currentFile.base && newVal?this.currentFile.base + newVal: newVal
            }
          })
        },
        immediate: true,
        deep: true
        },
      fixedNumber:{
        handler(val) {
        this.$nextTick(() => {
          this.option.fixedNumber = val || [1,1]
        })
        },
        immediate: true,
        deep: true
        },
      autoCropWidth(val){
        this.option.autoCropWidth = val
      },
       autoCropHeight(val){
        this.option.autoCropHeight = val
      },
      dialogVisible(val){
        if(!val){
          this.option.img = void 0
          this.$refs.upload.abort()
          this.$refs.upload.clearFiles()
        }
      }
	},
    methods:{
     
      finishUploadEvent(data) {
        const that = this
        const file = new window.File(
          [data], // blob
          that.fileinfo.name
        );
      let formData = new FormData();
      if(that.isMultiple)formData.append("files",file);
      else formData.append("file",file);
      
      that.loadFile(that.upAction,formData).then((res) => {
        // that.$message.success("上传成功!")
        // that.$set(that.formData, "avatar", res.path.url);
        that.dialogVisible = false;
        that.$nextTick(() => {
          that.$forceUpdate();
        });
      });
    },
        //上传前
        beforeUpload:function(file){
            const that = this
            let limitSize=file.size / 1024 / 1024;
            if(limitSize > this.size){
                that.$message({
                    message: '文件大小不得超过'+that.size+'M',
                    type: 'error'
                });
                that.$refs.upload.abort()
                that.$refs.upload.clearFiles()
                return false;
            }else{
               return true;
              
            }
        },
        //自定义上传
        myupload:function(content){
          
            const that = this
            if(!content.action) return 
            that.upAction= content.action
            that.fileinfo = content.file;
            let formData = new FormData();
            if(that.isMultiple)formData.append("files",content.file);
            else formData.append("file",content.file);
            
            // if(that.isUpload) that.loadFile(content.action,formData)
            // setTimeout(() => {
            //     if(that.isUpload) that.loadFile(content.action,formData)
            // }, 1000);
              if(that.checkSize(content.file)){
                if(that.isNeedLimit){
                if(content.file.type.indexOf('video') !== -1)
                {
                    let limitSize=content.file.size / 1024 / 1024;
                    if(limitSize > this.videoSize){
                        that.$message({
                            message: '文件大小不得超过'+that.videoSize+'M',
                            type: 'error'
                        });
                          that.$refs.upload.abort()
                          let uid = content.file.uid // 关键作用代码，去除文件列表失败文件
                          let idx = that.$refs.upload.uploadFiles.findIndex(item => item.uid === uid)
                          that.$refs.upload.uploadFiles.splice(idx, 1) // 关键作用代码，去除文件列表失败文件
                        return false;
                    }
                    that.loadFile(content.action,formData)
                }else{
                  that.imageRatio(content.file,  that.isNeedLimit ? 1 : void 0).then(q => {
                    if(!q){
                      if(that.isMultiple)
                      {
                      that.$message({
                            message: '文件尺寸比例请参考提示',
                            type: 'error'
                        });
                      that.$refs.upload.abort()
                      let uid = content.file.uid // 关键作用代码，去除文件列表失败文件
                      let idx = that.$refs.upload.uploadFiles.findIndex(item => item.uid === uid)
                      that.$refs.upload.uploadFiles.splice(idx, 1) // 关键作用代码，去除文件列表失败文件
                      }else{
                      that.$nextTick(() => {
                      //这里注意有些版本的element获取的文件信息没有url  , 这个时候需要这一步骤生成url
                        let url = window.URL.createObjectURL(content.file);
                        that.option.img = url;
                        that.dialogVisible = true;
                      });
                      }
                    }else  {
                      that.loadFile(content.action,formData)
                    }
                  }).catch(err => {

                      that.$refs.upload.abort()
                      let uid = content.file.uid // 关键作用代码，去除文件列表失败文件
                      let idx = that.$refs.upload.uploadFiles.findIndex(item => item.uid === uid)
                      that.$refs.upload.uploadFiles.splice(idx, 1) // 关键作用代码，去除文件列表失败文件
                    
                  })
                }
                }else {
                 
                  that.loadFile(content.action,formData)
                }
              }
            
            
        },
        loadFile(action,formData){
          const that = this
          return new Promise((resolve, reject) => {
          that.$axiosz.post(action,formData).then((r)=>{
                    if(r.code==200){
                        that.path=r.data.filePath;
                        that.currentFile = {
                          url:r.data.frontPath + r.data.filePath,
                          base:r.data.frontPath
                        }
                        that.$emit('input',r.data.filePath);
                        that.$message({
                            message: '上传成功',
                            type: 'success'
                        });
                        resolve(true)
                    }else{
                        that.$alert(r.msg);
                        reject(false)
                    }
                }).catch(e=>{
                    reject(false)
                })
          })
        },
        checkSize(file){
          let limitSize=0;//所有文件总大小
                let beforeSize=file.size;//上传前文件大小
                let fileSizeTotal=0;//已上传列表的文件数组总大小
                for(let item of this.fileSizeList){
                    fileSizeTotal+=item.size;
                }
                limitSize=(fileSizeTotal+beforeSize) / 1024 / 1024;
                if(this.isCalTotal && limitSize>this.size){
                    this.$message({
                        message: '文件总大小不得超过'+this.size+'M',
                        type: 'error'
                    });
                    return false;
                }else{
                    this.fileSizeList.push(file);
                    return true
                }
        },
        // 验证图片比例
        imageRatio(raw, param) {
          const that = this
          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(raw)
            reader.onload = () => {
              const img = new Image()
              img.src = reader.result
              img.onload = () => {
                const ratio = img.naturalWidth / img.naturalHeight
                if (that.isNeedLimit) {
                  if (!that.sizeList.includes(ratio)) {
                    const fileIdx = that.temp.length
                    that.temp.push(fileIdx)
                    if (that.activeIdx === -1) that.activeIdx = fileIdx
                    resolve(false)
                  } else {
                    
                    resolve(true)
                  }
                } else {
                  resolve(true)
                }
              }
            }
          })
        },
        //删除
        del:function(i){  
            this.fileList.splice(i,1);
            this.$emit('input',this.fileList);
        }
    },
    
    // mounted(){
    //   debugger
    //   // this.currentFile  = this.value
    //   if(this.$refs.upload){
    //     this.$refs.upload.clearFiles()

    //   }
    // }
}
</script>

<style lang="scss" scoped>
.warp{
  position: relative;
	/deep/ .el-input__inner{
		padding-right: 70px;
	}
    /deep/ .el-input__suffix{
        right: 0;
        .el-input__suffix-inner{
            height: 100%; 
            div{
                height: 100%;
            }
            .el-upload{
                height: 100%;
            }
        }
    }
    .btn{
        width:67px;
        background:rgba(239,239,239,0.5);
        border:1px solid rgba(229,229,229,1);
        font-size:12px;
        font-weight:400;
        text-align: center;
        color:rgba(177,177,177,1);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.super_input{
  // width:280px;
  //position:absolute;
  
  // z-index:0;
  /deep/  .el-input__inner{
    padding:0;
    height:32px;
    border-radius: 4px 0 0 4px;
  }
}
.super_upload{
  position: relative;
  z-index:1;
}
.super_input~.super_upload{
  /deep/ .el-button{
    border-radius: 0 3px 3px 0;
  }
}
.warp{
    display: flex;
    align-items: center;
    .btn{
        width:82px;
        height:35px;
        background:#1069DD;
        border-radius:3px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:35px;
        text-align: center;
        color:rgba(255,255,255,1);
    }
    .texts{
        font-size:10px;
        font-weight:400;
        color:rgba(177,177,177,1);
        margin-left: 27px;
        line-break: 16px;
    }
}
.attachment{
  margin-top:10px;
  li{
    margin-bottom:5px;
        display: flex;
    align-items: center;
    justify-content: flex-start;
    span{
      margin:0 5px;
    }
  }
}
</style>